import React, { useState } from 'react';
import 'twin.macro';
import { TabsWithUnderline } from 'components/Tabs/TabsWithUnderline';
import { useTranslation } from 'react-i18next';

const tabs = ['details', 'options'] as const;
type Tab = (typeof tabs)[number];

export function MobileBodyWithTabs({
  children,
  disabledTabs,
}: {
  children: [React.ReactNode, React.ReactNode, React.ReactNode];
  disabledTabs?: Tab[];
}) {
  const { t } = useTranslation(['cahierJournal']);
  const [selectedTab, setSelectedTab] = useState<Tab>(
    disabledTabs?.includes('details') ? 'options' : 'details',
  );

  return (
    <div tw="flex flex-col gap-y-4">
      {children[0]}
      <TabsWithUnderline<Tab>
        tw="block md:hidden -mx-4"
        onChange={setSelectedTab}
        tabs={tabs.map(tab => ({
          label: t(`cahierJournal:seance.modal.tabs.${tab}`),
          id: tab,
          current: selectedTab === tab,
          disabled: disabledTabs?.includes(tab),
        }))}
        display="grid"
        noSelect
      />
      <div>
        {selectedTab === 'details' && children[1]}
        {selectedTab === 'options' && children[2]}
      </div>
    </div>
  );
}
